import { Box, Container, Grid, makeStyles, Typography, Link } from "@material-ui/core";
import React from "react";
import { useSelector } from "react-redux";
import { colors } from "swyft-react-core";
import { EQuoteType } from "../../api/Types";
import { RootState } from "../../app/rootReducer";
import OverrideTheme from "../../components/OverrideTheme";
import { ReviewContainer } from "../quotePage/ReviewContainer";

const useStyles = makeStyles((theme) => ({
  root: {},
  alternate: {
    background: colors.alternate
  },
  button: {
    width: "90%",
    maxWidth: "17.5rem"
  },
  banner: {
    "backgroundSize": "cover",
    "backgroundPosition": "center",
    "width": "100%",
    "display": "flex",
    "alignItems": "center",
    "height": "140px",
    "backgroundImage": "url(images/sm/img-header-covid.jpg)",
    [theme.breakpoints.up("sm")]: {
      height: "210px"
    },
    [theme.breakpoints.up("md")]: {
      backgroundImage: "url(images/md/img-header-covid.jpg)",
      height: "360px"
    },
    [theme.breakpoints.up("lg")]: {
      backgroundImage: "url(images/lg/img-header-covid.jpg)"
    },
    [theme.breakpoints.up("xl")]: {
      backgroundImage: "url(images/xl/img-header-covid.jpg)"
    },
    "& h5": {
      maxWidth: "50%"
    }
  },
  images: {
    display: "flex",
    height: 400,
    margin: "auto"
  },
  tel: {
    color: colors.black,
    fontWeight: "bold"
  },
  numberedList: {}
}));

let strings = {
  "covid.header": "COVID-19 Update",

  "covid.section.1.header": "Keeping you safe",
  "covid.section.1.p.1":
    "In light of the recent development's with COVID 19, Swyft Energy have carefully considered its work ​processes. We have taken every precaution and step possible to ensure the safety of our installers, customers​ and our employees. We have implemented new ways to assess your home, again reinforcing the lack of ​contact and minimise chances of transmission.",
  "covid.section.1.p.2": "All safety measures are being reviewed on a daily basis in line with government guidance.",
  "covid.section.1.p.3":
    "For the safety of our customers and engineers, please: Adhere to social distancing (~2m) by avoiding ​being in the same room as the engineer.",
  "covid.section.1.p.4":
    "If you need to be in close proximity to our engineers at any point, please wear a mask to ensure your safety and the safety of our installers.",

  "covid.section.2.header": "During a Boiler installation",
  "covid.section.2.header.solar": "During a Solar installation",
  "covid.section.2.p.1":
    "Due to current health situation, we will keep time spent in your property to a minimum. Once on site, we will need access to the following places.",
  "covid.section.2.p.2": "During the solar installation, access is required to the following",

  "covid.section.3.header": "What to do when the installer is there?",
  "covid.section.3.p.1":
    "Our engineer will arrive at your home between 7.30am-10am on the morning of the installation. They will talk you through the job and answer any questions you may have.​",
  "covid.section.3.p.2":
    "To ensure the safety of you, the occupants of your home and our installers, we would kindly recommend that your household keep a safe distance from any installer entering your house. In the interest of safety for all, it is recommended to keep a safe 2 meter distance from our engineer.",

  "covid.section.4.header": "Will I be safe?",
  "covid.section.4.p.1":
    "Considering the recent development's with COVID 19, Swyft Energy have carefully considered our work processes. We have taken every precaution and step possible to ensure the safety of our installers and our employees.",
  "covid.section.4.p.2":
    "We will carry out a full background check before any work is carried out. This will involve determining whether you, the homeowner, has travelled to any affected areas or have been in proximity with a Covid-19 patient.",

  "covid.section.5.p.1":
    "If you or anyone in your household experience symptoms of Covid-19 (fever, fatique, dry cough, difficulty breathing) or come into close contact with someone confirmed or suspected of Covid-19, please contact us immediately on Cork: ",
  "covid.section.5.p.1.1": " or Dublin: ",
  "covid.section.5.p.1.2": " to reschedule your installation."
};

export const CovidPage: React.FC = () => {
  const classes = useStyles();
  // const theme = useTheme();

  const { quote } = useSelector((state: RootState) => state.quote);

  const type = quote?.type ?? EQuoteType.Boiler;

  const section2Boiler = (
    <Box py={3}>
      <Typography variant="h2" paragraph>
        {strings["covid.section.2.header"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.2.p.1"]}
      </Typography>
      <ul className={classes.numberedList}>
        <li>Your boiler</li>
        <li>Boiler flue outside (typically in back garden or side of property)</li>
        <li>Hot-press (lower half around tank should be cleared, only clothes on shelves above tank can remain)</li>
        <li>We may also need to look at radiator pipework in a few rooms</li>
      </ul>
    </Box>
  );

  const section2Solar = (
    <Box py={3}>
      <Typography variant="h2" paragraph>
        {strings["covid.section.2.header.solar"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.2.p.2"]}
      </Typography>
      <ul className={classes.numberedList}>
        <li>Pre-defined roof access via scaffolding and/or ladder</li>
        <li>Roof of the property</li>
        <li>Location of the Fuseboard</li>
        <li>Hot Water Cylinder &amp; surrounds</li>
        <li>
          Attic access point &amp; Attic void (Please ensure there is adequate space for our engineers to access the
          attic void &amp; move around freely in the attic space)
        </li>
      </ul>
    </Box>
  );

  let section2 = section2Boiler;
  switch (type) {
    case EQuoteType.Boiler:
      section2 = section2Boiler;
      break;
    case EQuoteType.Solar:
    case EQuoteType.BoilerSolar:
      section2 = section2Solar;
      break;
  }

  const section1 = (
    <Box py={3}>
      <Typography variant="h2" paragraph>
        {strings["covid.section.1.header"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.1.p.1"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.1.p.2"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.1.p.3"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.1.p.4"]}
      </Typography>
    </Box>
  );

  const section3 = (
    <Box py={3}>
      <Typography variant="h2" paragraph>
        {strings["covid.section.3.header"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.3.p.1"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.3.p.2"]}
      </Typography>
    </Box>
  );

  const section4 = (
    <Box py={3}>
      <Typography variant="h2" paragraph>
        {strings["covid.section.4.header"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.4.p.1"]}
      </Typography>
      <Typography variant="body1" paragraph>
        {strings["covid.section.4.p.2"]}
      </Typography>
    </Box>
  );

  const section5 = (
    <Box py={3}>
      <Typography variant="body1" paragraph>
        {strings["covid.section.5.p.1"]}
        <Link className={classes.tel} href="tel:+353217011238">
          (021) 701 1238
        </Link>
        {strings["covid.section.5.p.1.1"]}
        <Link className={classes.tel} href="tel:+35315042111">
          (01) 504 2111
        </Link>
        {strings["covid.section.5.p.1.2"]}
      </Typography>
    </Box>
  );

  const sections = (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {section1}
      </Grid>
      <Grid item xs={12}>
        {section2}
      </Grid>
      <Grid item xs={12}>
        {section3}
      </Grid>
      <Grid item xs={12}>
        {section4}
      </Grid>
      <Grid item xs={12}>
        {section5}
      </Grid>
    </Grid>
  );
  return (
    <React.Fragment>
      <Box className={classes.banner}>
        <Container maxWidth="lg">
          <Typography variant="h5" style={{ maxWidth: "50%" }}>
            {strings["covid.header"]}
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg">
        <Box py={3}>{sections}</Box>
      </Container>

      <Box className={classes.alternate} mb={2} py={4} textAlign="center">
        <OverrideTheme>
          <ReviewContainer />
        </OverrideTheme>
      </Box>
    </React.Fragment>
  );
};
